import { useState } from 'preact/hooks';
import { BaseCardView } from '../PRIVATE_BaseCardView';
import { Props } from '../UNSAFE_CardFlexView';

type CardGridProps<K extends string | number, D> = Props<K, D> & {
  /**
   * Provide the number of columns to render. The number of columns is required for CardGridView component.
   * If the number of columns is not provided, please use CardFlexView component.
   */
  columns: number;
};

export function CardGridView<K extends string | number, D>(props: CardGridProps<K, D>) {
  const [cardSize, setCardSize] = useState<{ width?: number; height?: number }>({});
  const updateCardSize = (width: number, height: number) => {
    setCardSize({ width, height });
  };

  return (
    <BaseCardView {...props} layout="grid" cardSize={cardSize} updateCardSize={updateCardSize} />
  );
}
